export const GET_SNAPS = 'GET_SNAPS';
export const GET_SNAPS_SUCCESS = 'GET_SNAPS_SUCCESS';
export const GET_SNAPS_FAILURE = 'GET_SNAPS_FAILURE';
export const ADD_SNAP = 'ADD_SNAP';
export const ADD_SNAP_SUCCESS = 'ADD_SNAP_SUCCESS';
export const ADD_SNAP_FAILURE = 'ADD_SNAP_FAILURE';
export const EDIT_SNAP = 'EDIT_SNAP';
export const EDIT_SNAP_SUCCESS = 'EDIT_SNAP_SUCCESS';
export const EDIT_SNAP_FAILURE = 'EDIT_SNAP_FAILURE';
export const DELETE_SNAP = 'DELETE_SNAP';
export const DELETE_SNAP_SUCCESS = 'DELETE_SNAP_SUCCESS';
export const DELETE_SNAP_FAILURE = 'DELETE_SNAP_FAILURE';
export const EXPORT_SNAP = 'EXPORT_SNAP';
